var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_c('main-visual', {
    attrs: {
      "code": "main-pc",
      "pc": ""
    }
  })], 1), _c('section', {
    staticClass: "main-section--auctions pt-0"
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('router-link', {
    staticClass: "main-section--auctions__link d-block px-10 py-40 pa-lg-50",
    attrs: {
      "to": "/auction-halls/A"
    }
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm"
  }, [_c('h3', {
    staticClass: "tit font-weight-regular line-height-1"
  }, [_vm._v("Live Auction")])]), _c('v-btn', {
    staticClass: "pa-4 ml-auto mr-n4 font-weight-medium",
    attrs: {
      "text": "",
      "color": "primary"
    }
  }, [_vm._v("VIEW MORE "), _c('i', {
    staticClass: "icon icon-bar mt-2 ml-6"
  })])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('router-link', {
    staticClass: "main-section--auctions__link d-block px-10 py-40 pa-lg-50",
    attrs: {
      "to": "/private-sales/LIST"
    }
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm"
  }, [_c('h3', {
    staticClass: "tit font-weight-regular line-height-1"
  }, [_vm._v("Private Sales")])]), _c('v-btn', {
    staticClass: "pa-4 ml-auto mr-n4 font-weight-medium",
    attrs: {
      "text": "",
      "color": "primary"
    }
  }, [_vm._v("VIEW MORE "), _c('i', {
    staticClass: "icon icon-bar mt-2 ml-6"
  })])], 1)], 1)], 1)], 1)], 1), _c('v-container', {
    staticClass: "container--large"
  }, [_c('main-text-banner')], 1), _c('main-section', {
    staticClass: "main-section--permanent",
    attrs: {
      "title": "Permanent Sales"
    }
  }, [_c('template', {
    slot: "title-actions"
  }, [_c('v-btn', {
    staticClass: "pa-4 ml-auto mr-n4",
    attrs: {
      "small": "",
      "text": "",
      "color": "primary",
      "to": "/permanent-sales"
    }
  }, [_vm._v("VIEW MORE "), _c('i', {
    staticClass: "icon icon-bar mt-2 ml-6"
  })])], 1), _c('main-permanent-sales')], 2), _c('div', {
    staticClass: "main-section main-section--link"
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_c('div', {
    staticClass: "mx-xl-n110"
  }, [_c('v-divider', {
    staticClass: "border-top grey-38"
  }), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "px-10 py-50 px-md-20 px-lg-40 py-lg-60 px-xl-120 py-xl-100"
  }, [_c('div', {
    staticClass: "tit-txt-wrap mb-20 mb-md-40"
  }, [_c('div', {
    staticClass: "tit-wrap mb-6 mb-md-10"
  }, [_c('h2', {
    staticClass: "tit font-weight-regular"
  }, [_vm._v("KATA YouTube")])]), _c('p', {
    staticClass: "tit-txt"
  }, [_vm._v("영상으로 보는 미술이야기")])]), _c('v-row', {
    staticClass: "row--small"
  }, _vm._l(_vm.categoriesYoutube, function (_ref) {
    var text = _ref.text,
        value = _ref.value;
    return _c('v-col', {
      key: value,
      attrs: {
        "cols": "6"
      }
    }, [_c('v-btn', {
      staticClass: "justify-start px-0 py-4",
      attrs: {
        "small": "",
        "block": "",
        "text": "",
        "height": "auto",
        "color": "primary",
        "to": "/board/youtube?category=".concat(value)
      }
    }, [_vm._v(_vm._s(text))]), _c('v-divider', {
      staticClass: "border-top grey-38"
    })], 1);
  }), 1)], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "px-10 py-50 px-md-20 px-lg-40 py-lg-60 px-xl-120 py-xl-100"
  }, [_c('div', {
    staticClass: "tit-txt-wrap mb-20 mb-md-40"
  }, [_c('div', {
    staticClass: "tit-wrap mb-6 mb-md-10"
  }, [_c('h2', {
    staticClass: "tit font-weight-regular"
  }, [_vm._v("KATA Report")])]), _c('p', {
    staticClass: "tit-txt"
  }, [_vm._v("보고서를 통한 유익한 핵심정보")])]), _c('v-row', {
    staticClass: "row--small"
  }, _vm._l(_vm.categoriesReport, function (_ref2) {
    var text = _ref2.text,
        value = _ref2.value;
    return _c('v-col', {
      key: value,
      attrs: {
        "cols": "6"
      }
    }, [_c('v-btn', {
      staticClass: "justify-start px-0 py-4",
      attrs: {
        "small": "",
        "block": "",
        "text": "",
        "height": "auto",
        "color": "primary",
        "to": "/board/report?category=".concat(value)
      }
    }, [_vm._v(_vm._s(text))]), _c('v-divider', {
      staticClass: "border-top grey-38"
    })], 1);
  }), 1)], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "px-10 py-50 px-md-20 px-lg-40 py-lg-60 px-xl-120 py-xl-100"
  }, [_c('div', {
    staticClass: "tit-txt-wrap mb-20 mb-md-40"
  }, [_c('div', {
    staticClass: "tit-wrap mb-6 mb-md-10"
  }, [_c('h2', {
    staticClass: "tit font-weight-regular"
  }, [_vm._v("KATA Archives")])]), _c('p', {
    staticClass: "tit-txt"
  }, [_vm._v("서식과 자료 중심의 이야기")])]), _c('v-row', {
    staticClass: "row--small"
  }, _vm._l(_vm.categoriesForms, function (_ref3) {
    var text = _ref3.text,
        value = _ref3.value;
    return _c('v-col', {
      key: value,
      attrs: {
        "cols": "6"
      }
    }, [_c('v-btn', {
      staticClass: "justify-start px-0 py-4",
      attrs: {
        "small": "",
        "block": "",
        "text": "",
        "height": "auto",
        "color": "primary",
        "to": "/board/forms?category=".concat(value)
      }
    }, [_vm._v(_vm._s(text))]), _c('v-divider', {
      staticClass: "border-top grey-38"
    })], 1);
  }), 1)], 1)])], 1)], 1)])], 1), _c('popup-layer')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }